import { render, staticRenderFns } from "./PagePoints.vue?vue&type=template&id=7e87787c&"
import script from "./PagePoints.vue?vue&type=script&lang=js&"
export * from "./PagePoints.vue?vue&type=script&lang=js&"
import style0 from "./PagePoints.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports